import { useLDFlag } from 'launchdarkly-vue-client-sdk';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

type SpanishSupportFlag = {
  enabled: string[];
};

/**
 * Whether the given contractor users are allowed to switch preferred language.
 * Always allowed outside prod; in prod, only for the contractor ids listed in
 * the `spanish-support2` flag.
 */
export function useCanSwitchLanguage(
  contractorId: MaybeRefOrGetter<string | null | undefined>
) {
  const spanishSupport = useLDFlag<SpanishSupportFlag>('spanish-support2', {
    enabled: []
  });

  return computed(() => {
    if (import.meta.env.VITE_ENV_NAME !== 'PROD') {
      return true;
    }
    // Resolved inside the computed so it updates once the contractor/job loads
    const id = toValue(contractorId);
    if (!id) {
      return false;
    }
    return spanishSupport.value.enabled.includes(id);
  });
}
